/* unplugin-vue-components disabled */
import Column from 'primevue/column'
import {DataTable} from 'components/data-table'
import EditModal from './edit-modal.vue'
import AddModal from './add-modal.vue'
import $shcontacts from 'stores/sh-contacts'

const LIMIT = 20

export default {
  components: {
    EditModal,
    AddModal,
    DataTable,
    Column
  },
  data() {
    return {
      loading: true,
      load_params: {skip: 0, limit: LIMIT, filter: ''},
    }
  },
  computed: {
    total(){
      return $shcontacts.total
    },
    view_items(){
      return $shcontacts.view_items
    },
    view_total(){
      return $shcontacts.view_total
    },
    refreshing() {
      return $shcontacts.loading
    },
    highlight () {
      return this.load_params.filter
    }
  },
  async mounted() {
    this.loading = true
    await $shcontacts.load(this.load_params)
    this.loading = false
  },
  methods: {
    async onPage(ev){
      this.load_params = {...this.load_params, skip: ev.first, limit: ev.rows}
      await $shcontacts.load(this.load_params)
    },
    async onCopyId(id) {
      await $utils.copyText(id)
    },
    async onSearch(filter){
      if (this.load_params.filter === filter) return
      this.load_params = {skip: 0, limit: LIMIT, filter}    
      await $shcontacts.load(this.load_params)
      this.$refs.search.focus()
    },
    onAddContact() {
      this.$refs.addModal.open()
    },
    onEditContact(id) {
      const shc = $shcontacts.getContact(id)
      this.$refs.editModal.open(shc)
    },
    async onNewContact(data) {
      try {
        await $shcontacts.newContact(data)
        await $shcontacts.load(this.load_params)
        $utils.toasts.success('Contact added successfully')
      }
      catch(err) {
        $utils.toasts.error(`Failed to add contact: ${err}`)
      }
      this.$refs.addModal.close(true)
    },
    async onUpdateContact(data) {
      const shc = $shcontacts.getContact(data.id)
      const old_first_name = shc.first_name
      const old_last_name = shc.last_name
      const old_middle_name = shc.middle_name
      const old_position = shc.position
      const old_lid  = shc.linkedin_id
      const old_shared_company_id  = shc.shared_company_id

      try {
        shc.first_name = data.first_name
        shc.last_name = data.last_name
        shc.middle_name = data.middle_name
        shc.position = data.position
        shc.linkedin_id = data.linkedin_id
        shc.shared_company_id = data.shared_company_id
        await shc.save()
        $utils.toasts.success('Contact updated successfully')
      }
      catch(err) {
        $utils.toasts.error(`Failed to update contact: ${err}`)
        shc.first_name = old_first_name
        shc.last_name = old_last_name
        shc.middle_name = old_middle_name
        shc.position = old_position
        shc.linkedin_id = old_lid
        shc.shared_company_id = old_shared_company_id
      }
      this.$refs.editModal.close(true)
    },
    async onUploadAvatar(contact_id, file) {
      if (!file) {
        return
      }
      const shc = $shcontacts.getContact(contact_id)
      await shc.uploadAvatar(file)
      $utils.toasts.success(`Avatar for ${shc.name} uploaded successfully`)
    }
  }
}
